export default {"src":"/_next/static/media/map-bg.0510846c.svg","height":1010,"width":1581,"blurWidth":0,"blurHeight":0};